export const PERMISSIONS = {
  FEATURES_MANAGE: 'FEATURES_MANAGE',
  USERS_LIST: 'USERS_LIST',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

export const PERMISSION_CATALOG: ReadonlyArray<{
  id: Permission;
  labelKey: 'permissionFeaturesManage' | 'permissionUsersList';
}> = [
  { id: PERMISSIONS.USERS_LIST, labelKey: 'permissionUsersList' },
  { id: PERMISSIONS.FEATURES_MANAGE, labelKey: 'permissionFeaturesManage' },
];
